import { css } from '@emotion/react';
import { flex } from '@spotnana/blocks/src/utils';
import { spacings } from '@spotnana/blocks/src/utils/styling/utilityTokens';

export const select_input = css`
  ${flex.init}
  ${flex.align.center}
  ${spacings.medium}
  overflow-x: hidden;
  text-overflow: ellipsis;
`;
